import * as React from 'react';
import { Utils, DateFormatter, domain, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';
import FondiAction from './fondi_action'
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import CompagnieActions from '../compagnie/CompagnieActions';

class FondiCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validation: new Map(),
            showConfirm: false,
        };
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.annullaButton = this.annullaButton.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaFondi = this.salvaFondi.bind(this);
        this.componentName = '[FondiCreate.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        this.props.getListCompagnie();
    }

    salvaFondi() {
        console.log("salva fondo")
        let modifica = false;
        if (this.props.location.state && this.props.location.state.modifica) {
            modifica = true;
        }
        this.setState({ showConfirm: false })
        this.props.salvaFondi(modifica).then(
            resolve => {
                console.log('resolve di salvaFondi')
                this.props.history.push({ pathname: '/fondi/details', state: { fonId: resolve.fonId } })

            }
        );
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['fonDescrizione', 'fonTipo']; // 'fonId'

        if (this.props.detailsFondi.fonTipo === 'OICR') {
            required.push('fonIsin')
        }
        // if (this.props.detailsFondi.fonValMinPercentuale <= 0 || this.props.detailsFondi.fonValMinPercentuale >= 100) {
        //     console.log(this.componentName + 'minperc');
        //     validation.set('fonValMinPercentuale', i18n('ARM_CORE_PRODUCT.SHARED.PERCENTUALE', 'percentuale non consentita '));
        // }
        // if (this.props.detailsFondi.fonValMaxPecentuale <= 0 || this.props.detailsFondi.fonValMaxPecentuale >= 100) {
        //     console.log(this.componentName + 'maxPerc');
        //     validation.set('fonValMaxPecentuale', i18n('ARM_CORE_PRODUCT.SHARED.PERCENTUALE', 'percentuale non consentita '));
        // }
        for (let i = 0; i < required.length; i++) {

            if (this.props.detailsFondi[required[i]] === undefined || this.props.detailsFondi[required[i]] === '' || this.props.detailsFondi[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }

        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }

        let firstKey = validation.keys().next().value;

        $('html, body').animate({
            scrollTop: $("#" + firstKey).offset().top - 70
        }, 1000);


        return false;
    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            console.log(this.componentName + 'inputChangeHandler' + id);
            if (type === "date" && value !== undefined) {
                let data = new Date(value);
                value = data.getTime();
            }
            if (type === "number" && value === "") {
                value = null;
            }
            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }

            this.props.handleChange(id, value).then(
                resolve => {
                    if (id === 'fonTipo' && value !== 'OICR') {
                        this.props.handleChange("fonIsin", null)
                    }
                }
            )
        }

    }

    showConfirmPanel() {
        console.log(" show pop up");
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }
        console.log('show dopo blocco if')
        this.setState({ showConfirm: true })
    }


    annullaButton() {
        console.log(this.componentName + 'annullaButton');
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.history.push({ pathname: '/fondi/details', state: { id: this.props.location.state.fonId } });
        }
        else {
            this.props.history.goBack();
        }

    }

    render() {
        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>
                        {this.props.location.state && this.props.location.state.modifica ?
                            <div >
                                {i18n('ARM_CORE_PRODUCT.FONDO.MODIFICA_FONDO_CON_ID', 'Modifica del fondo con id: ')} {this.props.location.state.id}
                            </div>
                            :
                            <div>
                                {i18n('ARM_CORE_PRODUCT.FONDO.CREAZIONE_NUOVO_FONDO', 'Creazione Nuovo Fondo')}
                            </div>
                        }
                    </agui.aCardV4Header>

                    <agui.aCardV4Body>
                        <div>
                            <div className="row mt-4">
                                {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="fonId" type="text"
                                        value={this.props.detailsFondi.fonId}
                                        placeholder="inserire codice"
                                        required
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.CODICE', 'Codice')}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler} />
                                </div> */}

                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="fonDescrizione" type="text"
                                        value={this.props.detailsFondi.fonDescrizione}
                                        placeholder="inserire descrizione"
                                        required
                                        label={i18n('ARM_CORE_PRODUCT.FONDO.DESRIZIONE', 'Descrizione')}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="fonTipo"
                                        required={true}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler}
                                        value={this.props.detailsFondi.fonTipo}
                                        label={i18n('ARM_CORE_PRODUCT.FONDO.TIPO', 'Tipo')}
                                        items={domain("AI_TIPO_FONDO")}
                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />
                                </div>
                          
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="divisa"
                                        disabled={false}
                                        onChange={this.inputChangeHandler}
                                        value={this.props.detailsFondi ? this.props.detailsFondi.divisa : null}
                                        label={i18n('ARM_CORE_PRODUCT.FONDO_CODICE_BANCA.DIVISA', 'Divisa ')}
                                        items={domain('COD_DIVPORT')}
                                        validation={this.state.validation}
                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="fonIsin" type="text"
                                        value={this.props.detailsFondi.fonIsin}
                                        validation={this.state.validation}
                                        placeholder="inserire codice ISIN"
                                        label={i18n('ARM_CORE_PRODUCT.FONDO.CODICE.ISIN', 'Codice isin')}
                                        required={this.props.detailsFondi && this.props.detailsFondi.fonTipo === 'OICR'}
                                        onChange={this.inputChangeHandler} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="fonCodBanca" type="number"
                                        value={this.props.detailsFondi.fonCodBanca}
                                        validation={this.state.validation}
                                        placeholder="inserire codice banca"
                                        label={i18n('ARM_CORE_PRODUCT.FONDO_CODICE_BANCA', 'Codice banca')}
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>

                        </div>
                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.annullaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4>
                <agui.ConfirmModalSaveV4
                    show={this.state.showConfirm}
                    saveOnClick={this.salvaFondi}
                    onClose={() => this.setState({ showConfirm: false })} />

            </div>
        )
    }

}
function mapStateToProps(state) {
    return {
        detailsFondi: state.fondi.detailsFondi,
        listCompagnie: state.compagnie.listaCompagnie
    }
}

function mapDispatchToProps(dispatch) {
    return {
        salvaFondi(modifica) {
            return dispatch(FondiAction.salvaFondi(modifica));
        },
        getListCompagnie() {
            return dispatch(CompagnieActions.getListCompagnie())
        },
        clearAll() {
            return dispatch(FondiAction.clearAll());
        },
        handleChange(index, e) {
            return dispatch(FondiAction.handleChange(index, e))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FondiCreate);

//finevalidità non obbligatiria ma possibilità di inserirla

// fondo-prodotto deve dire se fondo è eliminato

//o importo o percentuale != null max e min

//number input all'onchange o onclick